import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {  MessageService, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';

import { ApiService } from 'src/app/_services/api.service';
import { GridService } from 'src/app/_services/grid.service';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';
import { FreezeService, TreeGrid } from '@syncfusion/ej2-angular-treegrid';
import { CellSelectEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { OverlayPanel } from 'primeng/overlaypanel';
import { forkJoin } from 'rxjs';
import { JavaRedirectComponent } from '../../java-redirect/java-redirect.component';

@Component({
  selector: 'app-checkl-results',
  templateUrl: './checkl-results.component.html',
  styleUrls: ['./checkl-results.component.css'],
  providers: [ MessageService,FreezeService]
  
})

export class ChecklResultsComponent implements OnInit {
  
  @ViewChild('linktoarkiweb') linktoarkiweb: ElementRef;

  
  @ViewChild('treegrid')
  public treegrid: TreeGrid;
  @ViewChild("op") op: OverlayPanel;
  selColumnField:string='';
  detailContent:string='';
  detailIdarkiweb:number=null;
  detailActivityType:string=null;
  detailDomanda:string='';
  detailStruttura:string='';
  selTarget:any;
  questionari: SelectItem[] = [];  
  treegridColumns:any;
  struttureList:any[]=[];
  strutturelistSelected:any[]=[];
  onlyLastCheckList:boolean=false;
  checkllist: any[] = [];
  allaDataSel:Date;
  treeGridWidth=0;
  dallaDataSel:Date;
  filtro={
    questionario:null

  };
  ufficiList:any[]=[];
  tipologieList:any[]=[];
  argomentiList:any[]=[];
  isLoading:boolean=true;
  cdcList:any[]=[];
  repartiList:any[]=[];
  vocidispesaList:any[]=[];
  statlist:any[]=[];
  prioritaList:any[]=[
   {
     value:"B",
     text:"Bassa"
   },
   {
     value:"M",
     text:"Media"
   },
   {
     value:"A",
     text:"Alta"
   },
  ];
  gridApi;
  columns: ColDef[] = [
    { field: 'struttura',  
      headerName: 'Struttura',
      minWidth:200,
    },
    { field: 'datacheckList',  
      headerName: 'Data questionario',
      minWidth:130,
    },
    { field: 'risposteSI',  
      headerName: 'Totale Si',
      minWidth:130,
    },
    { field: 'risposteNO',  
      headerName: 'Totale No',
      minWidth:130,
    },
    { field: 'percSI',  
      headerName: 'Perc. Si',
      minWidth:130,
    },
    { field: 'percNO',  
      headerName: 'Perc. No',
      minWidth:130,
    },
    { field: 'segnalazioni',  
      headerName: 'Segnalazioni',
      minWidth:130,
    },
    { field: 'non_conformita',  
      headerName: 'Non conformità',
      minWidth:130,
    },
    { field: 'arkiman',  
      headerName: 'Manutenzioni',
      minWidth:130,
    },

  ];
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };
  constructor(
   
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService
  ) { }

  
  ngOnInit(): void {
    let argomenti=this.apiService.get('checklists/checkl_getargomentisegnalazioni',{});
    let tipi=this.apiService.get('checklists/checkl_gettipisegnalazioni',{});
    let uffici=this.apiService.get('checklists/checkl_getuffici',{});
    let vocidispesa=this.apiService.get('checklists/checkl_getvocidispesa',{});
    let cdc=this.apiService.get('checklists/checkl_getcdc',{});
    let reparti=this.apiService.get('checklists/checkl_getreparti',{});
   
    
    
    forkJoin([ argomenti,tipi,uffici,vocidispesa,cdc,reparti]).subscribe(data => {
      this.ufficiList=data[2].Result;
      this.tipologieList=data[1].Result;
      this.argomentiList=data[0].Result;
      this.vocidispesaList=data[3].Result;
      this.cdcList=data[4].Result;
      this.repartiList=data[5].Result;

    });

    this.treeGridWidth=window.innerWidth-160;
    const params: any = {PageSize : 10000};
    this.apiService.get('checklists/listall',params).subscribe(data => {
      data.Result.forEach((q)=>{
        this.questionari.push({
          label:q.name,value:q.id
        });
      });
      this.apiService.get('checklists/checkl_getstrutture',{}).subscribe(datastrutture => {
        this.struttureList=datastrutture.Result;
      });
    });
   
  }

  
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
   
    
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  load(){

    if (!this.filtro.questionario) {
      this.addSingle('error', 'Error', 'Selezionare un questionario');
      return;
    }
    let params: any = {showresults : true};

    if(this.dallaDataSel) {
      params.periodfrom=moment(this.dallaDataSel).format('YYYY-MM-DD');
    }
    if(this.allaDataSel) {
      params.periodto=moment(this.allaDataSel).format('YYYY-MM-DD');
    }

    params.questionario=this.filtro.questionario;
    params.strutture=this.strutturelistSelected;
    params.onlyLastCheckList=this.onlyLastCheckList;
    
    this.apiService.get('checklists/checkl_listallresults',params).subscribe(data => {
      this.treegridColumns= data.Result.columns;
      this.statlist= data.Result.stat;
      setTimeout(() => {
        this.treegrid.refreshColumns(true);
        this.treegrid.dataSource=data.Result.data;
        this.treegrid.refresh();
 
        this.treegrid.element.addEventListener('mousedown',  (e)=> {
          if ((e.target as HTMLElement).closest('td') != null && 
          (e.target as HTMLElement).closest('td').classList.contains("e-rowcell") && 
         !(e.target as HTMLElement).classList.contains("e-treegridexpand") && 
         !(e.target as HTMLElement).classList.contains("e-treegridcollapse")) {
          let index: number = parseInt((e.target as HTMLElement).closest('td').getAttribute('Index') as string);
          let colIndex: number = parseInt((e.target as HTMLElement).closest('td').getAttribute("aria-colIndex"));
         this.selColumnField= this.treegridColumns[colIndex-1].field;

         this.detailContent='';
         this.detailDomanda='';
         this.detailStruttura=this.treegridColumns[colIndex-1].headerText;
         this.selTarget=e;
         this.treegrid.selectRows([index]);
         // this.op.hide();
      
          setTimeout(()=>{
            if(this.detailContent!='')
              this.op.show(e);
          },100);
         }
        });
        this.gridApi.redrawRows();
      }, 500);
      
    });
  }

  
  cellSelected(args: CellSelectEventArgs) {
    var cellSelected: object[] = this.treegrid.getSelectedRowCellIndexes() as object[];
    var cellSelectedCount: number = cellSelected.length;
    alert('Selected row cell count : ' + cellSelectedCount)
}
nuovaattivitaHtml(obj,objId){
  let strHtml='';
  if(obj['attivita']=='arkiman'){
    this.detailActivityType='arkiman';
    strHtml+='<b>Aperta nuova manutenzione</b><br>';
  }
  if(obj['attivita']=='segnalazione'){
    this.detailActivityType='segnalazione';
    strHtml+='<b>Aperta nuova segnalazione</b><br>';
  }
  if(obj['attivita']=='non_conformita'){
    this.detailActivityType='non_conformita';
    strHtml+='<b>Aperta nuova non conformità</b><br>';
  }

  
  strHtml+='<table>';
  for (const key in  obj){
    let value='';
    if(key=='centrodicosto'){
      value=this.cdcList.filter((x)=>x.value==obj[key])[0].text;
    }
    if(key=='argomento'){
      value=this.argomentiList.filter((x)=>x.value=obj[key])[0].text;
    }
    if(key=='reparto'){
      value=this.repartiList.filter((x)=>x.value==obj[key])[0].text;
    }
    if(key=='ufficio'){
      value=this.ufficiList.filter((x)=>x.value==obj[key])[0].text;
    }
    if(key=='tipologia'){
      value=this.tipologieList.filter((x)=>x.value==obj[key])[0].text;
    }
    if(key=='vocedispesa'){
      value=this.vocidispesaList.filter((x)=>x.value==obj[key])[0].text;
    }
    if(obj[key]==true){
      value="SI";
    }
    if(obj[key]==false){
      value="NO";
    }

    strHtml+='<tr><td>'+key+'</td>';
    if(value!=''){
      strHtml+='<td>'+value+'</td></tr>';
    } else {
      strHtml+='<td>'+obj[key]+'</td></tr>'; 
    }

  
  }

  if(objId){
        this.detailIdarkiweb=objId;
        strHtml+='</table>';                  
        this.detailContent+=strHtml;
  } else {
    strHtml+='</table>'; 
    this.detailContent+=strHtml;
    this.detailIdarkiweb=null;
  }
}

rowSelected (args) { 
  if(this.selColumnField!=''){
    if(args.data[0][this.selColumnField+'_morematrix']){
      if(args.data[0][this.selColumnField+'_more']){
        this.detailContent=args.data[0][this.selColumnField+'_more'];
      }
      args.data[0][this.selColumnField+'_morematrix'].activityList.forEach((act,ind)=>{
        this.nuovaattivitaHtml(act,args.data[0][this.selColumnField+'_morematrix'].activityListId[ind]);
      });
    } else {
      if(args.data[0][this.selColumnField+'_more']){
        if(typeof args.data[0][this.selColumnField+'_more'] === 'object' ){
          this.nuovaattivitaHtml(args.data[0][this.selColumnField+'_more'],args.data[0][this.selColumnField+'_attivita_id']);
        } else {
          this.detailContent=args.data[0][this.selColumnField+'_more'];
        }
        this.detailDomanda=args.data[0]['question'];
        this.selColumnField='';
      } else {
        this.op.hide();
      }  
    }
  } else {
      this.op.hide();
  }
} 

goto(){
  let logInfo = JSON.parse(localStorage.getItem("logInfo"));
  if(this.detailActivityType=='segnalazione'){
    let params={
      oper:6,
      id_sign:this.detailIdarkiweb,
      password:logInfo.password,
      userNamelogin:logInfo.username
    }
    this.globalService.submitForm('sign/login/LogonServletSign','POST',params);
  }
  if(this.detailActivityType=='non_conformita'){
    let params={
      password:logInfo.password,
      userNamelogin:logInfo.username
    }
    this.globalService.submitForm('sign/login/LogonServletSign?oper=8&id_nc='+this.detailIdarkiweb,'POST',params);
  }
  if(this.detailActivityType=='arkiman'){
    let params={
      oper:1,
      reind:'manutenzione',
      id_manutenzione:this.detailIdarkiweb,
      password:logInfo.password,
      userNamelogin:logInfo.username
    }
    this.globalService.submitForm('arkiman/login/LogonServletMAN','POST',params);
  }
  
}

}
